var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mine"},[_c('nav-bar',{attrs:{"title":"密码设置","left-arrow":""}}),_c('van-cell',{attrs:{"title":_vm.$t('修改安全密碼'),"is-link":"","to":"changepay","clearable":"","border":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }